/* tslint:disable */
/* eslint-disable */
/**
 * Internal Datadoc API
 * Service to maintain and expose metadata for data in Statistics Norway. Includes the following concepts:  - Data File: A logically defined blob of data from a file system or object storage. - Dataset: A collection of related Data Files which together represent a coherent dataset. These are typically partitioned by time periods. - Data Product: A collection of related Data Files that are produced and maintained by a Dapla team. All data which does not directly contribute to publication of a statistic on ssb.no is defined as a Data Product. - Statistic Product: A collection of related Data Files that are produced and maintained by a Dapla team, and directly contribute to publication of a statistic on ssb.no. The list of all statistic products is defined by the Statistic Register. 
 *
 * The version of the OpenAPI document: 0.1
 * Contact: metadata@ssb.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the processing state of a dataset as expressed in the Dapla path structure.
 * @export
 */
export const DatasetState = {
    SOURCE_DATA: 'SOURCE_DATA',
    INPUT_DATA: 'INPUT_DATA',
    PROCESSED_DATA: 'PROCESSED_DATA',
    STATISTICS: 'STATISTICS',
    OUTPUT_DATA: 'OUTPUT_DATA'
} as const;
export type DatasetState = typeof DatasetState[keyof typeof DatasetState];


export function instanceOfDatasetState(value: any): boolean {
    for (const key in DatasetState) {
        if (Object.prototype.hasOwnProperty.call(DatasetState, key)) {
            if (DatasetState[key as keyof typeof DatasetState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DatasetStateFromJSON(json: any): DatasetState {
    return DatasetStateFromJSONTyped(json, false);
}

export function DatasetStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetState {
    return json as DatasetState;
}

export function DatasetStateToJSON(value?: DatasetState | null): any {
    return value as any;
}

export function DatasetStateToJSONTyped(value: any, ignoreDiscriminator: boolean): DatasetState {
    return value as DatasetState;
}

